module.exports = __webpack_public_path__ + "static/img/0000挂缴查.4c10e09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000挂缴查.jpg
// module id = NJL8
// module chunks = 0